import React, { useEffect, useRef } from 'react';

// Accepts watch?v=, youtu.be/, shorts/ and embed/ links.
export const youtubeId = (url = '') => {
  const m = url.match(/(?:youtu\.be\/|v=|shorts\/|embed\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
};

const IS_IOS = typeof navigator !== 'undefined' && /iPhone|iPad|iPod/i.test(navigator.userAgent);

// YouTube player that autoplays and calls onEnded when the video finishes, using the
// IFrame API's postMessage protocol (no extra script to load).
const TheatrePlayer = ({ url, title, onEnded }) => {
  const iframeRef = useRef();
  const id = youtubeId(url);
  const onEndedRef = useRef(onEnded);
  onEndedRef.current = onEnded;

  useEffect(() => {
    const onMessage = (e) => {
      if (!/^https:\/\/(www\.)?youtube(-nocookie)?\.com$/.test(e.origin || '')) return;
      let data;
      try { data = typeof e.data === 'string' ? JSON.parse(e.data) : e.data; } catch (err) { return; }
      const ended =
        (data?.event === 'onStateChange' && data.info === 0) ||
        (data?.event === 'infoDelivery' && data.info?.playerState === 0);
      if (ended) onEndedRef.current?.();
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, []);

  // Ask the player to send us events once it has loaded.
  const handleLoad = () => {
    const win = iframeRef.current?.contentWindow;
    if (!win) return;
    win.postMessage(JSON.stringify({ event: 'listening', id: 1, channel: 'widget' }), '*');
    win.postMessage(JSON.stringify({ event: 'command', func: 'addEventListener', args: ['onStateChange'], id: 1, channel: 'widget' }), '*');
  };

  if (!id) return <div className="w-full h-full flex items-center justify-center text-white/70">Video unavailable</div>;

  const params = new URLSearchParams({
    autoplay: '1',
    mute: IS_IOS ? '1' : '0', // iOS only autoplays muted; viewers can unmute in the player
    playsinline: '1',
    rel: '0',
    modestbranding: '1',
    enablejsapi: '1',
    origin: window.location.origin,
  });

  return (
    <iframe
      key={id}
      ref={iframeRef}
      onLoad={handleLoad}
      title={title}
      src={`https://www.youtube-nocookie.com/embed/${id}?${params}`}
      className="w-full h-full border-0"
      allow="autoplay; encrypted-media; picture-in-picture; fullscreen"
      allowFullScreen
    />
  );
};

export default TheatrePlayer;
